import { Details } from '../Details/Details';
import { XButton } from '../XButton/XButton';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { hasPublisherHaveBackgroundImage } from '@/utils/publisher';
import { useIsMobile } from '@/hooks/useIsMobile';
import { isLandscape } from '@/utils/device';

export const TopWrapper = () => {
  const context = useContext(CheckoutContext);
  const {
    boot,
    actions: { closeCheckout },
    template,
  } = context;
  const isMobile = useIsMobile();
  const hasBackgroundImage = hasPublisherHaveBackgroundImage(boot?.checkoutTheme, template.type);
  const backgroundImage = hasBackgroundImage
    ? isMobile
      ? boot?.checkoutTheme?.mobileBgImage || boot?.checkoutTheme?.backgroundImage
      : boot?.checkoutTheme?.backgroundImage
    : undefined;

  return (
    <div
      className="flex flex-col items-center justify-center md:w-2/5 md:justify-start bg-cover bg-center bg-top md:h-full landscape:w-2/5 landscape:h-[100dvh] landscape:justify-start"
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
    >
      {isMobile && !isLandscape() && (
        <XButton onClick={() => closeCheckout(context)} style={{ color: boot?.checkoutTheme?.textColor }} />
      )}
      <Details />
    </div>
  );
};
